"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSearchOptionSection = void 0;
exports.defaultSearchOptionSection = {
    translate: {
        findAnAgent: 'Find an Agent',
        findByFirstLastName: 'Find by First/Last Name'
    },
    spokenLanguageOptions: [
        {
            regionalName: 'Languages Spoken',
            spokenLanguageId: 0
        },
        {
            regionalName: 'English',
            spokenLanguageId: 6
        },
        {
            regionalName: '粵語',
            spokenLanguageId: 2
        },
        {
            regionalName: '国语',
            spokenLanguageId: 3
        },
        {
            regionalName: 'Francais',
            spokenLanguageId: 7
        },
        {
            regionalName: 'Deutsch',
            spokenLanguageId: 8
        },
        {
            regionalName: 'हिन्दी',
            spokenLanguageId: 10
        },
        {
            regionalName: 'Italiano',
            spokenLanguageId: 11
        },
        {
            regionalName: '日本語',
            spokenLanguageId: 12
        },
        {
            regionalName: 'Bahasa Melayu/Bahasa Indonesia',
            spokenLanguageId: 15
        },
        {
            regionalName: 'Język Polski',
            spokenLanguageId: 18
        },
        {
            regionalName: 'Português',
            spokenLanguageId: 19
        },
        {
            regionalName: 'Español',
            spokenLanguageId: 23
        },
        {
            regionalName: 'Tagalog',
            spokenLanguageId: 26
        }
    ]
};
